export default "__VITE_ASSET__DjejPPcm__"